(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';
  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  var sections = document.querySelectorAll('[data-dietitian-how-it-works]');

  sections.forEach(function (section) {
    var list = section.querySelector('.dietitian-how-it-works__list');
    if (!list) return;

    var isMobile = window.matchMedia ? window.matchMedia(MOBILE_QUERY).matches : true;
    if (!isMobile) return;

    var reducedMotion = window.matchMedia
      ? window.matchMedia(REDUCED_MOTION_QUERY).matches
      : false;

    if (reducedMotion) {
      list.classList.add('is-horizontal');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      list.classList.add('is-horizontal');
      return;
    }

    var hasPlayed = false;

    function morphToHorizontal() {
      if (hasPlayed) return;
      hasPlayed = true;

      var steps = Array.prototype.slice.call(list.querySelectorAll('.dietitian-how-it-works__step'));

      var firstRects = steps.map(function (step) {
        return step.getBoundingClientRect();
      });

      list.classList.add('is-horizontal');

      var lastRects = steps.map(function (step) {
        return step.getBoundingClientRect();
      });

      steps.forEach(function (step, i) {
        var dx = firstRects[i].left - lastRects[i].left;
        var dy = firstRects[i].top - lastRects[i].top;
        step.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      });

      requestAnimationFrame(function () {
        steps.forEach(function (step) {
          step.classList.add('is-animating');
        });

        requestAnimationFrame(function () {
          steps.forEach(function (step) {
            step.style.transform = '';
          });
        });
      });

      window.setTimeout(function () {
        steps.forEach(function (step) {
          step.classList.remove('is-animating');
          step.style.transform = '';
        });
      }, 700);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            morphToHorizontal();
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(section);
  });
})();